import React from 'react';
import {OffersContextProvider} from '../index';
import {Outlet} from 'react-router-dom';

const RouteContextOfferWrapper: React.FC = () => {
  return (
    <OffersContextProvider>
      <Outlet />
    </OffersContextProvider>
  );
};

export default RouteContextOfferWrapper;
